import { tns } from 'tiny-slider/src/tiny-slider'

function heroSlider () {
  document.querySelectorAll('.hero-slider').forEach(sliderNode => {
    const slider = tns({
      container: sliderNode.querySelector('.hero-slider__items'),
      items: 1,
      loop: true,
      autoplay: true,
      mode: 'gallery',
      slideBy: 1,
      nav: false,
      autoplayButtonOutput: false,
      speed: 800,
      controls: false,
    })

    slider.events.on('transitionEnd', () => window.lazyLoad.update())

    sliderNode.querySelectorAll('.l-hero__tags a').forEach(tag => {
      tag.addEventListener('mouseover', e => {
        slider.goTo(tag.dataset.index - 1)
        slider.pause()
      })
      tag.addEventListener('mouseout', e => {
        slider.play()
      })
    })
  })
}

function impressionsSlider () {
  document.querySelectorAll('.impressions-images-slider').forEach(sliderNode => {
    tns({
      container: sliderNode.querySelector('.impressions-images-slider__items'),
      items: 1,
      loop: true,
      autoplay: true,
      mode: 'gallery',
      slideBy: 1,
      nav: false,
      autoplayButtonOutput: false,
      speed: 800,
      controls: false,
    })
  })
}

export default function () {
  heroSlider()
  impressionsSlider()
}
